import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';
import { SelectItem } from '@web/shared/ui';
import { AdminShipmentSizeType } from '../enums/admin-shipment-size-type';

@Injectable({
  providedIn: 'root',
})
export class AdminShipmentSizeTypeProviderService {
  private readonly entries = new Map<AdminShipmentSizeType, string>([
    [AdminShipmentSizeType.Small, 'Mała'],
    [AdminShipmentSizeType.Medium, 'Średnia'],
    [AdminShipmentSizeType.Large, 'Duża'],
  ]);

  public labelFor(type: AdminShipmentSizeType): Observable<string> {
    const result = this.entries.get(type);

    if (isNil(result)) {
      throw new EntryNotFoundException(`The entry for "${type}" is not found.`);
    }

    return of(result);
  }

  public selectItems(): Observable<SelectItem<AdminShipmentSizeType>[]> {
    return of(
      Array.from(this.entries.entries()).map(
        ([type, label]) => new SelectItem<AdminShipmentSizeType>(label, type),
      ),
    );
  }
}
